var _effectorFileName = "/src/shared/components/promo-modal/timer.ts";
import { differenceInDays, differenceInHours, differenceInMilliseconds, differenceInMinutes, differenceInSeconds, endOfDay, isAfter } from 'date-fns';
export const AD_PROMO_SHOW_DELAY_MS = 2000;
const COUNTDOWN_UNITS = ['d', 'h', 'm', 's'] as const;

/** Local end of 15 August 2026. */
export const getPromoDeadlineEnd = () => endOfDay(new Date(2026, 7, 15));
export const isPromoDeadlinePassed = (now: Date = new Date(), deadline: Date = getPromoDeadlineEnd()) => isAfter(now, deadline);
export const getPromoRemainingMs = (now: Date = new Date(), deadline: Date = getPromoDeadlineEnd()) => Math.max(0, differenceInMilliseconds(deadline, now));
const pad2 = (value: number) => String(Math.max(0, value)).padStart(2, '0');

/** Countdown like `00d 00h 00m 00s`. */
export const formatPromoCountdown = (ms: number) => {
  const [daysUnit, hoursUnit, minutesUnit, secondsUnit] = COUNTDOWN_UNITS;
  if (ms <= 0) {
    return `00${daysUnit} : 00${hoursUnit} : 00${minutesUnit} : 00${secondsUnit}`;
  }
  const start = new Date(0);
  const end = new Date(ms);
  const days = differenceInDays(end, start);
  const hours = differenceInHours(end, start) % 24;
  const minutes = differenceInMinutes(end, start) % 60;
  const seconds = differenceInSeconds(end, start) % 60;
  return `${pad2(days)}${daysUnit} : ${pad2(hours)}${hoursUnit} : ${pad2(minutes)}${minutesUnit} : ${pad2(seconds)}${secondsUnit}`;
};